/* =========================================================
   FYNDIT — Theme JavaScript (vanilla, no dependencies)
   Features: mobile menu, search overlay, category dropdown,
   AJAX add to cart, cart count updates, wishlist, carousel.
   ========================================================= */
(function () {
  'use strict';

  var routes = window.fynRoutes || {};
  var strings = window.fynStrings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts || false); }

  var docBound = {};
  function bindOnce(el, key) {
    if (!el) return false;
    var k = 'fyn' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* -------------------------------------------------------
     HEADER — scroll shadow
     ------------------------------------------------------- */
  function initHeaderScroll() {
    var header = $('[data-header]');
    if (!header || !bindOnce(header, 'Scroll')) return;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    update();
    on(window, 'scroll', update, { passive: true });
  }

  /* -------------------------------------------------------
     MOBILE MENU
     ------------------------------------------------------- */
  function initMobileMenu() {
    var toggle = $('[data-menu-toggle]');
    var drawer = $('[data-mobile-nav]');
    if (!toggle || !drawer || !bindOnce(toggle, 'Menu')) return;

    function openMenu() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
      var firstLink = drawer.querySelector('a, button.fyn-drawer__close');
      if (firstLink) window.setTimeout(function () { firstLink.focus(); }, 60);
    }

    function closeMenu() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
    }

    on(toggle, 'click', function () {
      drawer.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    $all('[data-menu-close]', drawer).forEach(function (el) {
      on(el, 'click', closeMenu);
    });

    $all('a', drawer).forEach(function (link) {
      on(link, 'click', closeMenu);
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeMenu();
    });
  }

  /* -------------------------------------------------------
     SEARCH OVERLAY
     ------------------------------------------------------- */
  function initSearch() {
    var toggle = $('[data-search-toggle]');
    var panel = $('[data-search-panel]');
    if (!toggle || !panel || !bindOnce(toggle, 'Search')) return;
    var closeBtn = $('[data-search-close]', panel);
    var input = $('[data-search-input]', panel);

    function open() {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (input) window.setTimeout(function () { input.focus(); }, 50);
    }
    function close() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    on(toggle, 'click', function () {
      panel.classList.contains('is-open') ? close() : open();
    });
    on(closeBtn, 'click', close);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
    on(document, 'click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });
  }

  /* -------------------------------------------------------
     CATEGORY DROPDOWN
     ------------------------------------------------------- */
  function initDropdowns() {
    var items = $all('[data-dropdown]');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = $('[data-dropdown-toggle]', item);
      if (!trigger || !bindOnce(item, 'Dropdown')) return;

      on(trigger, 'click', function (e) {
        e.stopPropagation();
        var isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var t = $('[data-dropdown-toggle]', other);
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      });

      on(item, 'mouseleave', function () {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    if (docBound.dropdown) return;
    docBound.dropdown = true;

    on(document, 'click', function () {
      $all('[data-dropdown]').forEach(function (item) {
        item.classList.remove('is-open');
        var t = $('[data-dropdown-toggle]', item);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      $all('[data-dropdown]').forEach(function (item) { item.classList.remove('is-open'); });
    });
  }

  /* -------------------------------------------------------
     CART — count updates + AJAX add to cart
     ------------------------------------------------------- */
  function setCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    if (!routes.cart) return;
    fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setCartCount(cart.item_count); })
      .catch(function () {});
  }

  function initAjaxCart() {
    if (!routes.cartAdd) return;

    $all('[data-cart-form]').forEach(function (form) {
      if (form.dataset.fynBound === '1') return;
      form.dataset.fynBound = '1';
      on(form, 'submit', function (e) {
        e.preventDefault();
        var btn = $('[data-add-to-cart]', form);
        if (btn && (btn.disabled || btn.classList.contains('is-loading'))) return;

        var body = new FormData(form);
        if (btn) btn.classList.add('is-loading');

        fetch(routes.cartAdd, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (btn) btn.classList.remove('is-loading');
            if (!res.ok) {
              window.alert((res.data && res.data.description) || strings.cartError || 'Could not add to cart');
              return;
            }
            if (btn) {
              btn.classList.add('is-done');
              window.setTimeout(function () { btn.classList.remove('is-done'); }, 1200);
            }
            refreshCartCount();
            document.dispatchEvent(new CustomEvent('fyn:cart:added', { detail: res.data }));
          })
          .catch(function () {
            if (btn) btn.classList.remove('is-loading');
            window.alert(strings.cartError || 'Could not add to cart');
          });
      });
    });
  }

  /* -------------------------------------------------------
     WISHLIST — localStorage backed
     ------------------------------------------------------- */
  var WISHLIST_KEY = 'fyn:wishlist';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }

  function writeWishlist(list) {
    try { window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function updateWishlistBadge() {
    var count = readWishlist().length;
    $all('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function syncWishlistButtons() {
    var ids = readWishlist().map(function (i) { return String(i.id); });
    $all('[data-wishlist]').forEach(function (btn) {
      var active = ids.indexOf(String(btn.getAttribute('data-product-id'))) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.innerHTML = active ? '&#9829;' : '&#9825;';
    });
  }

  function renderWishlistDrawer() {
    var listEl = $('[data-wishlist-list]');
    if (!listEl) return;
    var items = readWishlist();
    if (!items.length) {
      listEl.innerHTML = '<p class="fyn-drawer__empty">Your wishlist is empty.</p>';
      return;
    }
    listEl.innerHTML = items.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '<img alt="">';
      return '<div class="fyn-wish-item" data-wish-row="' + i.id + '">' +
        img +
        '<div><strong>' + escapeHtml(i.title || 'Product') + '</strong>' +
        (i.url ? '<small><a href="' + i.url + '">View product</a></small>' : '') +
        '</div>' +
        '<button type="button" data-wish-remove="' + i.id + '" aria-label="Remove">&times;</button>' +
        '</div>';
    }).join('');
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toggleWishlistItem(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var list = readWishlist();
    var idx = list.map(function (i) { return String(i.id); }).indexOf(String(id));
    if (idx === -1) {
      list.push({
        id: id,
        title: btn.getAttribute('data-product-title') || '',
        url: btn.getAttribute('data-product-url') || '',
        image: btn.getAttribute('data-product-image') || ''
      });
    } else {
      list.splice(idx, 1);
    }
    writeWishlist(list);
    updateWishlistBadge();
    syncWishlistButtons();
    renderWishlistDrawer();
  }

  function initWishlist() {
    if (docBound.wishlist) {
      updateWishlistBadge();
      syncWishlistButtons();
      renderWishlistDrawer();
      return;
    }
    docBound.wishlist = true;

    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-wishlist]');
      if (btn) {
        e.preventDefault();
        toggleWishlistItem(btn);
        return;
      }

      var openBtn = e.target.closest('[data-wishlist-open]');
      if (openBtn) {
        e.preventDefault();
        openWishlistDrawer();
        return;
      }

      if (e.target.closest('[data-wishlist-close]')) {
        closeWishlistDrawer();
        return;
      }

      var removeBtn = e.target.closest('[data-wish-remove]');
      if (removeBtn) {
        var id = removeBtn.getAttribute('data-wish-remove');
        var list = readWishlist().filter(function (i) { return String(i.id) !== String(id); });
        writeWishlist(list);
        updateWishlistBadge();
        syncWishlistButtons();
        renderWishlistDrawer();
      }
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') closeWishlistDrawer();
    });

    updateWishlistBadge();
    syncWishlistButtons();
    renderWishlistDrawer();
  }

  function openWishlistDrawer() {
    var drawer = $('[data-wishlist-drawer]');
    if (!drawer) return;
    renderWishlistDrawer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }

  function closeWishlistDrawer() {
    var drawer = $('[data-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  /* -------------------------------------------------------
     CAROUSEL / SLIDER (New arrivals + any [data-slider])
     ------------------------------------------------------- */
  function initSliders() {
    $all('[data-slider]').forEach(function (wrap) {
      var track = $('[data-slider-track]', wrap);
      var prev = $('[data-slider-prev]', wrap);
      var next = $('[data-slider-next]', wrap);
      if (!track || !bindOnce(wrap, 'Slider')) return;

      function step() {
        var card = track.querySelector('.fyn-product-card');
        var cardWidth = card ? card.getBoundingClientRect().width : track.clientWidth / 2;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '14') || 14;
        var visible = Math.max(1, Math.round(track.clientWidth / (cardWidth + gap)));
        return (cardWidth + gap) * Math.max(1, visible - 1);
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      }

      on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(track, 'scroll', function () { window.requestAnimationFrame(updateArrows); }, { passive: true });
      on(window, 'resize', updateArrows);
      updateArrows();
    });
  }

  /* -------------------------------------------------------
     Shopify Theme Editor lifecycle
     ------------------------------------------------------- */
  function initAll() {
    initHeaderScroll();
    initMobileMenu();
    initSearch();
    initDropdowns();
    initAjaxCart();
    initWishlist();
    initSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
  document.addEventListener('shopify:section:select', function () {
    initSliders();
  });
})();
